import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AddinView } from '@techwan/ionic-core';
import { DepartureTicketInfo } from '../../schema/departure-ticket-info';
import { DepartureTicketInfoService } from '../../services/departure-ticket-info/departure-ticket-info.service';

@AddinView({
  name: 'CallcardDepartureTicketInfo'
})
@Component({
  selector: 'app-departure-ticket-info-collapsible-view',
  templateUrl: './departure-ticket-info-collapsible-view.component.html',
  styleUrls: ['./departure-ticket-info-collapsible-view.component.scss']
})
export class DepartureTicketInfoCollapsibleViewComponent implements OnInit {
  departureTicketInfo: DepartureTicketInfo;
  fireColumns: string;

  constructor(private departureTicketInfoService: DepartureTicketInfoService, private translate: TranslateService) {}

  ngOnInit() {
    this.departureTicketInfo = this.departureTicketInfoService.departureTicketInfo;

    this.fireColumns = [
      this.departureTicketInfo.ParkingFireColumn ? this.translate.instant('Mobile.Parking') : '',
      this.departureTicketInfo.BuildingFireColumn ? this.translate.instant('Mobile.Building') : ''
    ]
      .filter(text => text)
      .join(', ');
  }
}
